// Candidate Saga
import CandidateSaga from "./candidate/saga";
import CandidateRegistrationSaga from "./candidateregistration/saga";
import CandidateFormSaga from "./candidateForm/saga";
import CandidateMappingSaga from "./candidateMapping/saga";
export {
  CandidateSaga,
  CandidateRegistrationSaga,
  CandidateFormSaga,
  CandidateMappingSaga,
};
